import { renderMarkers } from '../markers/renderMarkers'
import { createMap } from './createMap'
import { setFormId, bindForm } from '../form/bindForm'
import { getRoutesAndMarkersData } from '../utils/getRoutesAndMarkersData'
import createLoader from '../utils/loader/createLoader'
import { setOpts, setColors, setStringConstants } from '../utils/constants'
import renderOffers from '../offers'

/*
  functions executed after routes and airports are loaded from server
   - must be executed in specific order
*/
const callBacks = {
  createMap,
  renderMarkers,
  renderOffers,
  bindForm
}

const initializeAiticketMap = opts => {
  // creating loader till everything is prepare to show
  createLoader()

  // setting options as constants
  setOpts(opts)
  setColors(opts.colors)
  setFormId(opts.form.id)
  setStringConstants(opts.strings)

  // get data from server and start rendering
  getRoutesAndMarkersData(opts, callBacks)
}

export default initializeAiticketMap



// WEBPACK FOOTER //
// ./app/map/initialize.js